import {
  CallChaining,
  FormFieldWidget,
  ModelFieldType,
  QueryService,
  SPI,
  ValidatorInfo,
  ValidatorStatus,
  ViewType,
  Widget,
  http
} from '@kunlun/dependencies';
import Payments from './Payments.vue';
import { FormInstance } from 'ant-design-vue/lib/form';
import Decimal from 'decimal.js';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.OneToMany,
    widget: 'CreditPay',
    multi: true
  })
)
export class PaymentsWidget extends FormFieldWidget {
  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  @Widget.Reactive()
  private validation1 = {
    help: '',
    status: ValidatorStatus.Success
  };

  @Widget.Reactive()
  private formLoading = false;

  private formInstance!: FormInstance;

  aboveFlag = false;

  public initialize(props) {
    super.initialize(props);
    this.setComponent(Payments);
    return this;
  }

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  private setOriginPayAmount() {
    (this.formData.creditFundBooks as any[]).forEach((i) => {
      i.payAmount = Number(i.payAmount).toFixed(2);
      i.originPayAmount = i.payAmount;
    });
    (this.formData.fundBooks as any[]).forEach((i) => {
      i.payAmount = Number(i.payAmount).toFixed(2);
      i.originPayAmount = i.payAmount;
    });
    (this.formData.rebateFundBooks as any[]).forEach((i) => {
      i.payAmount = Number(i.payAmount).toFixed(2);
      i.originPayAmount = i.payAmount;
    });
  }

  private resetFundBookds() {
    this.formData.creditFundBooks = [];
    this.formData.fundBooks = [];
    this.formData.rebateFundBooks = [];
  }

  private mountedProcess() {
    this.setOriginPayAmount();

    console.table(
      ((this.formData?.creditFundBooks as any[]) ?? []).map((i) => ({
        名称: i.fundBookName,
        最小可用额度: i.payMinUseBalance,
        支付金额: i.payAmount,
        最大可用额度: i.payMaxUseBalance
      }))
    );
    console.table(
      ((this.formData?.fundBooks as any[]) ?? []).map((i) => ({
        名称: i.fundBookName,
        最小可用额度: i.payMinUseBalance,
        支付金额: i.payAmount,
        最大可用额度: i.payMaxUseBalance
      }))
    );
    console.table(
      ((this.formData?.rebateFundBooks as any[]) ?? []).map((i) => ({
        名称: i.fundBookName,
        最小可用额度: i.payMinUseBalance,
        支付金额: i.payAmount,
        最大可用额度: i.payMaxUseBalance
      }))
    );
  }

  @Widget.Reactive()
  private setFormInstance(formInstance: FormInstance) {
    this.formInstance = formInstance;
  }

  @Widget.Watch('formData.checkedAccountTypeList', { deep: true })
  watchCheckPayType(val) {
    if (val && !val.length) {
      this.validation1 = {
        help: '请选择支付方式',
        status: ValidatorStatus.Error
      };
      this.resetFundBookds();
    } else {
      this.validation1 = {
        help: '',
        status: ValidatorStatus.Success
      };
    }
  }

  @Widget.Method()
  private async changePayType(value) {
    try {
      this.formLoading = true;
      const gql = `
      query {
        deliAriesBuyerPayConfirmQuery {
          constructMirror (
            data: {
              tradeOrderId: "${this.formData.tradeOrderId}"
              tradeOrderCode: "${this.formData.tradeOrderCode}"
              checkedAccountTypeList: [${this.formData.checkedAccountTypeList}]
            }
          ) {
            creditFundBooks {
              fundBookId
              fundBookName
              payMinUseBalance
              payMaxUseBalance
              usableAmount
              payAmount
              eidtable
            }
            fundBooks {
              fundBookId
              fundBookName
              payMinUseBalance
              payMaxUseBalance
              usableAmount
              payAmount
              eidtable
            }
            rebateFundBooks {
              fundBookId
              fundBookName
              payMinUseBalance
              payMaxUseBalance
              usableAmount
              payAmount
              eidtable
            }
          }
        }
      }
      
      `;
      const res = await http.query(this.model.moduleName, gql);
      for (let k in res.data.deliAriesBuyerPayConfirmQuery.constructMirror) {
        this.formData[k] = res.data.deliAriesBuyerPayConfirmQuery.constructMirror[k];
      }
      this.setOriginPayAmount();
    } catch (error) {
      console.error(error);
    } finally {
      this.formLoading = false;
    }
  }

  @Widget.Method()
  private async changePayValue(value) {
    try {
      this.formLoading = true;
      // this.mountedProcess();
      const creditNum = (this.formData.creditFundBooks as any[]).reduce(
        (p, c) => new Decimal(p).plus(new Decimal(c.payAmount || '0').minus(new Decimal(c.originPayAmount))).toNumber(),
        0
      );
      const rebateNum = (this.formData.rebateFundBooks as any[]).reduce(
        (p, c) => new Decimal(p).plus(new Decimal(c.payAmount || '0').minus(new Decimal(c.originPayAmount))).toNumber(),
        0
      );

      if ((this.formData.fundBooks as any[]).length) {
        (this.formData.fundBooks as any[])[0].payAmount = new Decimal(
          (this.formData.fundBooks as any[])[0].originPayAmount
        ).minus(new Decimal(creditNum).plus(rebateNum).toNumber());

        if ((this.formData.fundBooks as any[])[0].payAmount < 0) {
          (this.formData.fundBooks as any[])[0].payAmount = 0;
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.formLoading = false;
    }
  }

  @Widget.Method()
  setAboveFlag(val: boolean) {
    this.aboveFlag = val;
  }

  public async validator(): Promise<ValidatorInfo> {
    try {
      if (this.validation1.status === ValidatorStatus.Error) {
        throw new Error('请选择支付方式');
      } else if (this.aboveFlag) {
        throw new Error('支付金额超过应付款金额，请仔细核对');
      }
      await this.formInstance.validate();
    } catch (error: any) {
      setTimeout(() => {
        this.formInstance.clearValidate(this.field.name);
      }, 0);
      return {
        message: '',
        status: ValidatorStatus.Error,
        path: ''
      };
    }

    return {
      message: '',
      status: ValidatorStatus.Success,
      path: ''
    };
  }
}
